/**
 * Tab Recursos — alocação das pessoas do projeto.
 * V1 simples: lista as pessoas, fases atribuídas, horas estimadas.
 */

import React, { useMemo } from 'react';

export default function Recursos({ projeto, fases }) {
  const porPessoa = useMemo(() => {
    const m = {};
    fases.filter((f) => !f.eh_buffer).forEach((f) => {
      const uid = f.responsavel?.id ?? 'sem';
      const key = f.responsavel?.nome || 'Sem responsável';
      if (!m[key]) m[key] = { fases: [], horasEst: 0, horasReal: 0, id: uid };
      m[key].fases.push(f);
      m[key].horasEst += parseFloat(f.horas_estimadas || 0);
      m[key].horasReal += parseFloat(f.horas_consumidas || 0);
    });
    return Object.entries(m).sort((a, b) => b[1].horasEst - a[1].horasEst);
  }, [fases]);

  return (
    <div style={cardStyle}>
      <h3 style={{ margin: '0 0 16px', color: '#2c3e50' }}>
        Alocação de recursos ({porPessoa.length} pessoa(s))
      </h3>
      {porPessoa.map(([nome, info]) => (
        <div key={nome} style={{
          padding: 16, borderBottom: '1px solid #ecf0f1',
          display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: 16, alignItems: 'center',
        }}>
          <div>
            <div style={{ fontWeight: 600, color: '#2c3e50' }}>{nome}</div>
            <div style={{ color: '#7f8c8d', fontSize: '0.8rem' }}>{info.fases.length} fase(s)</div>
          </div>
          <div>
            <div style={{ fontSize: '0.8rem', color: '#7f8c8d' }}>Horas</div>
            <div>
              <b>{info.horasReal.toFixed(1)}h</b>
              <span style={{ color: '#7f8c8d' }}> / {info.horasEst.toFixed(1)}h</span>
            </div>
          </div>
          <div>
            {info.fases.map((f) => (
              <span key={f.id} style={{
                display: 'inline-block', margin: '2px 4px 2px 0',
                padding: '2px 8px', background: '#ecf0f1', borderRadius: 10,
                fontSize: '0.75rem', color: '#555',
              }} title={`${f.horas_estimadas}h estimadas`}>
                {f.nome}
              </span>
            ))}
          </div>
        </div>
      ))}
      {porPessoa.length === 0 && <p style={{ color: '#bdc3c7' }}>Sem responsáveis atribuídos.</p>}
    </div>
  );
}

const cardStyle = { background: '#fff', borderRadius: 12, padding: 20,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
